import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
    fetchFormRecords,
    fetchFormRecordsFail,
    fetchFormRecordsSuccess
} from './translations.action';
import { Item, Section, Translation } from './translations.model';

export interface TranslationsRecordsState {
    listData: Translation[];
    listFormData: Item[];
    sections: Section[];
    items: Item[];
    singleData: Translation;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: TranslationsRecordsState = {
    listData: [],
    listFormData: [],
    sections: [],
    items: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};

export const TranslationssRecordReducer = createReducer(

    initialState,

    //Fetch Records
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),


    //Fetch Form Table
    on(fetchFormRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchFormRecordsSuccess, (state, { listFormData, total }) => {
        return { ...state, listFormData, total, loading: false };
    }),
    on(fetchFormRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),


    on(fetchSingleRecordSuccess, (state, { singleData, sections, items }) => {
        return { ...state, singleData, sections, items, error: null };
    }),

    
    on(resetState, () => initialState)  // Reset action handler
    
);